import React from "react";
import styled from "styled-components";
import { dataConstants } from "../../../shared/data/dataConstants";
const DisplayContainer = styled.div.withConfig({
  displayName: "ErrorBoundaryDisplay__DisplayContainer",
  componentId: "sc-1uxamov-0"
})(["display:flex;justify-content:center;align-items:center;min-height:100vh;h1{margin:0 0 .67em 0;}"]);
const Display = styled.div.withConfig({
  displayName: "ErrorBoundaryDisplay__Display",
  componentId: "sc-1uxamov-1"
})(["color:red;margin:1em;padding:2em;box-shadow:0 0 1em black;"]);
const Line = styled.div.withConfig({
  displayName: "ErrorBoundaryDisplay__Line",
  componentId: "sc-1uxamov-2"
})(["white-space:pre-wrap;"]);
export const ErrorBoundaryDisplay = ({
  error,
  insideErrorBoundary
}) => {
  return /*#__PURE__*/React.createElement(DisplayContainer, null, /*#__PURE__*/React.createElement(Display, null, /*#__PURE__*/React.createElement("h1", null, "You found a bug that crashed the app"), /*#__PURE__*/React.createElement("div", null, "Sorry that happened! Please copy & paste the following error as text (not as a screenshot) to a developer, and explain what you did before it happened."), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("div", null, "The current date/time is: ", new Date().toLocaleString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
    hour: "2-digit",
    "minute": "2-digit",
    second: "2-digit",
    hour12: false
  })), dataConstants.sentryDSN && /*#__PURE__*/React.createElement("div", null, "This was also sent to Sentry."), !dataConstants.sentryDSN && /*#__PURE__*/React.createElement("div", null, "Sentry isn't active, so this was not sent to Sentry."), /*#__PURE__*/React.createElement("br", null), !insideErrorBoundary && /*#__PURE__*/React.createElement("div", null, "Note that this error was somehow caught OUTSIDE of the error boundary. Please tell Tobias Wehrum that this happened.", /*#__PURE__*/React.createElement("br", null)), error !== null && error !== void 0 && error.stack ? /*#__PURE__*/React.createElement(Line, null, "Uncaught ", error === null || error === void 0 ? void 0 : error.stack) : /*#__PURE__*/React.createElement(Line, null, "Uncaught ", error === null || error === void 0 ? void 0 : error.name, ": ", error === null || error === void 0 ? void 0 : error.message)));
};